import { classNames } from "@/react/helpers/twMergeWithCN";
import type { BadgeProperty } from "@/react/types/PaywallCustomization";

import { usePaywallCustomizationContext } from "../PaywallCustomizationProvider";
import { Badge } from "./Badge";

interface BadgesProps {
  className?: string;
}

export const Badges = ({ className }: BadgesProps) => {
  const { paywallCustomization } = usePaywallCustomizationContext();

  const { enabled: isBadgeEnabled, badges } =
    paywallCustomization?.badge_properties || {
      enabled: false,
      badges: [],
    };

  if (!isBadgeEnabled) {
    return null;
  }

  return (
    <div className={classNames("flex flex-row flex-wrap gap-2", className)}>
      {badges.map((badge: BadgeProperty) => (
        <Badge key={badge.id} {...badge} />
      ))}
    </div>
  );
};
